import React, { useState } from 'react';

const QrAssetUpdateIcon = ({handleUpdateQrAsset}) => {
    return(
        <React.Fragment>
            <img src={require('../../assets/img/qr-asset-rollout.png')} 
                style={{width: "50px", float: "right", cursor: "pointer"}}
                alt="Update QR" id="QrIcon" onClick={handleUpdateQrAsset}/>
            <div className="clearfix"/>
        </React.Fragment>
    );
};

export default QrAssetUpdateIcon;